import { useParams, useNavigate } from 'react-router'
import Page from '@/components/common/Page'
import HistoryTab from '@/pages/clients/ClientContent/HistoryTab'

export default function HistoryPage() {
  const { clientId } = useParams<{ clientId: string }>()
  const navigate = useNavigate()

  if (!clientId) return null

  const handleViewRun = (runId: string) => {
    if (!runId) return
    void navigate(`/workspace/clients/${clientId}/campaigns?runId=${runId}`)
  }

  return (
    <Page
      title="History"
      helpContent={{
        header: 'Campaign History',
        body: (
          <div>
            <p>Review all past campaign executions and generated content. Track what's been created and analyze performance trends.</p>
            <h4>Features:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li>View all historical campaign runs</li>
              <li>See what content was generated and when</li>
              <li>Filter by campaign or date range</li>
              <li>Click to view detailed generated content</li>
              <li>Track which campaigns perform best</li>
            </ul>
            <h4>Tips:</h4>
            <p>Use history to understand content patterns and optimize future campaigns based on what worked best.</p>
          </div>
        ),
      }}
    >
      <HistoryTab clientId={clientId} onViewRun={handleViewRun} />
    </Page>
  )
}
